export type Formatter = (v: string) => string

export function defaultFormatter(value: string): string {
	let result = value.replace(/\s+/g, ' ')
	// eslint-disable-next-line no-control-regex
		.replace(/[\u0000-\u001F]+/g, '')
		.replace(/[\u007F-\u009F]+/g, '')
	return result.replace(/[{[<]/g, '')
}

export function inputFormatter(value: string): string {
	return value.replace(/[$]/g, '')
}

export function emailFormatter(value: string): string {
	return value.replace(/[(),:;'"]/g, '')
}

export function naturalNumberFormatter(value: string): string {
	return value.replace(/\D/g, '')
}

export function compose(...formatters: Array<Formatter>) {
	return (value: string): string => {
		if (!formatters.length) return value
		let result: string = value
		formatters.forEach(formatter => {
			result = formatter(result)
		})
		return result
	}
}
